import { render, staticRenderFns } from "./TextAndPictureQuestion.vue?vue&type=template&id=0906103c&scoped=true"
import script from "./TextAndPictureQuestion.vue?vue&type=script&lang=js"
export * from "./TextAndPictureQuestion.vue?vue&type=script&lang=js"
import style0 from "./TextAndPictureQuestion.vue?vue&type=style&index=0&id=0906103c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906103c",
  null
  
)

export default component.exports